export default __webpack_public_path__ + "static/media/frg--indoor-pool.b0aa385a.png";